export const programmes = [
    {
        key: "nys-programme",
        value: "National Youth Service (NYS)",
    },
    {
        key: "events-tracker",
        value: "SEIMS Events App",
    },
    // {
    //     key: "citizen-science",
    //     value: "Citizen Science",
    // },
    {
        key: "volunteer-scientist",
        value: "Volunteer Scientists/STEM Professionals",
    },
    // {
    //     key: "stemi-olympiad",
    //     value: "STEMI Olympiad",
    // }
];